import { render, staticRenderFns } from "./subscribeTabBar.vue?vue&type=template&id=c55d1aea&scoped=true"
import script from "./subscribeTabBar.vue?vue&type=script&lang=js"
export * from "./subscribeTabBar.vue?vue&type=script&lang=js"
import style0 from "./subscribeTabBar.vue?vue&type=style&index=0&id=c55d1aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d1aea",
  null
  
)

export default component.exports